import { Badge } from '@freelancer-os/ui/src/components/ui/badge';
import { Button } from '@freelancer-os/ui/src/components/ui/button';
import { Clock, PanelRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ChatHeaderProps {
  title: string;
  artifactVisible: boolean;
  onToggleArtifact: () => void;
}

export function ChatHeader({
  title,
  artifactVisible,
  onToggleArtifact,
}: ChatHeaderProps) {
  const { t } = useTranslation('chat');
  return (
    <header className="h-[56px] border-b border-surface-200 flex items-center justify-between px-5 bg-surface-0/80 backdrop-blur-sm shrink-0">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-brand-400 animate-pulse" />
          <h1 className="text-[14.5px] font-semibold text-surface-800">
            {title}
          </h1>
        </div>
        <Badge
          variant="outline"
          className="text-[11px] font-mono font-medium text-surface-400 bg-surface-100 px-2 py-0.5 border-surface-200 rounded-none"
        >
          LangGraph Agent
        </Badge>
      </div>
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          className="text-surface-400 hover:text-surface-600 hover:bg-surface-100"
          title={t('header.history')}
        >
          <Clock className="w-[18px] h-[18px]" strokeWidth={1.8} />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleArtifact}
          className={
            artifactVisible
              ? 'text-brand-600 bg-brand-50'
              : 'text-surface-400 hover:text-brand-600 hover:bg-brand-50'
          }
          title={t('header.viewInvoice')}
        >
          <PanelRight className="w-[18px] h-[18px]" strokeWidth={1.8} />
        </Button>
      </div>
    </header>
  );
}
